<template>
  <div class="footer">
    <div class="rep container">

        <div class="text">
			<p>
	   			 Major League Baseball trademarks and copyrights are used with permission of MLB Advanced Media, L.P.
	   			 All rights reserved <a href="https://www.mlb.com/official-information/terms-of-use" target="_blank">Terms of Use</a> |
	   			 <a href="https://www.mlb.com/official-information/privacy-policy" target="_blank">Privacy Policy</a>
   		 	</p>
        </div>
     </div>

  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 5px 25px;
  margin-left: 230px;
  // overflow:hidden;
  // width: 100%;
  // position: fixed;
  font-family: 'Verlag Book';
  bottom: 0;
  background: theme-var($--ch-theme-secondary);
  z-index: 22;
  @include media-breakpoint-down(sm) {
	  margin-left: 0px;
  }
  @include media-breakpoint-only(md) {
	   margin-left: 0px;
  }
  .rep {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 0 10em;
    // @include media-breakpoint-down(xl) {
    //   padding: 0 8em;
    // }
    overflow: hidden;
    // @include media-breakpoint-down(md) {
    //   padding: 0 2em;
    //   flex-direction: column;
    // }
    p {
      margin: 0;
	  text-align:center;
	  color:white;
      line-height: 1.6em;
    }
    a {
      color:white !important;
    }
    .title {
      color: theme-var($--ch-theme-on-secondary);
      font-size: 10px;
    }
    .left {
      display: flex;
      font-family: Roboto;
      font-size: 14px;
      align-items: center;
      justify-content: center;
      @include media-breakpoint-down(sm) {
        font-size: 12px;
        line-height: 1.5em;
        text-align: center;
      }
      font-style: normal;
      font-weight: 400;
      line-height: 23px;
      letter-spacing: 0px;
      text-align: left;
      text-transform: uppercase;
      @include media-breakpoint-down(sm) {
        flex-direction: column;
        align-items: center;
      }
      .avatar {
        @include media-breakpoint-down(sm) {
          display: none;
        }
        margin-right: 20px;
        display: flex;
        align-items: center;
        border-radius: 50%;
        overflow: hidden;
        height: 50px;
        width: 50px;
        img {
          height: 50px;
          width: 50px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
